import axios from "axios";
import { Cookies } from "react-cookie";
import { proxy } from "../config";
const cookie = new Cookies();

export const getHelpTeam = async () => {
    const token = await cookie.get("token");
    return await axios.get(`${proxy}/team/all`, {
        headers: { Authorization: token }
    });
};

export const addHelpTeam = async (formData) => {
    const token = await cookie.get("token");
    return await axios.post(`${proxy}/team/create`, formData, {
        headers: { Authorization: token }
    });
};

export const updateHelpTeam = async (id, formData) => {
    const token = await cookie.get("token");
    return await axios.put(`${proxy}/team/update/${id}`, formData, {
        headers: { Authorization: token }
    });
};

export const deleteHelpTeam = async (id) => {
    const token = await cookie.get("token");
    return await axios.delete(`${proxy}/team/delete/${id}`, {
        headers: { Authorization: token }
    });
};